<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-flex xs12 sm6 md4 xl3 class="pa-2">
        <SelectCreditors
          :multiple="false"
          :selected="localFilters.creditor_id"
          :loading="loading"
          @selectedCreditors="localFilters.creditor_id = $event"
        ></SelectCreditors>
      </v-flex>

      <v-flex xs12 sm6 md4 xl3 class="pa-2">
        <div :class="{ 'is-disabled': loading || !localFilters.creditor_id }">
          <v-md-date-range-picker
            :opens="'right'"
            @change="handleChange"
            :presets="presets"
            :start-date="localFilters.start_date"
            :end-date="localFilters.end_date"
          ></v-md-date-range-picker>
        </div>
      </v-flex>

      <v-flex xs12 sm6 md4 xl2 class="pa-2">
        <SelectGateways
          v-model="localFilters.gateway_id"
          :loading="loading"
          :disabled="!localFilters.creditor_id"
        />
      </v-flex>

      <v-flex xs12 sm6 md4 xl2 class="pa-2">
        <SelectStrategicPublic
          v-model="localFilters.strategy_public"
          :loading="loading"
          :disabled="!localFilters.creditor_id"
        />
      </v-flex>

      <v-flex xs12 sm6 md4 xl2 class="pa-2">
        <SelectApproachTypes
          v-model="localFilters.approach_type"
          :loading="loading"
          :disabled="!localFilters.creditor_id"
        />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import moment from "moment";
import SelectCreditors from "@/components/creditor/SelectCreditors";
import SelectStrategicPublic from "@/components/selects/SelectStrategicPublic.vue";
import SelectGateways from "@/components/selects/SelectGateways.vue";
import SelectApproachTypes from "@/components/selects/SelectApproachTypes.vue";

export default {
  name: "IncentiveFiringsFilters",
  components: {
    SelectCreditors,
    SelectStrategicPublic,
    SelectGateways,
    SelectApproachTypes,
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      localFilters: {
        start_date: moment().subtract(0, "day").format("YYYY-MM-DD"),
        end_date: moment().subtract(0, "day").format("YYYY-MM-DD"),
        creditor_id: null,
        strategy_public: null,
        gateway_id: null,
        approach_type: null,
      },
      presets: [
        { label: "Hoje", range: this.getRange(0, 0) },
        { label: "Ontem", range: this.getRange(1, 1) },
        { label: "Últimos 7 dias", range: this.getRange(6, 0) },
        { label: "Últimos 30 dias", range: this.getRange(29, 0) },
        { label: "Este mês", range: this.getRange(0, 0, "month") },
        { label: "Mês passado", range: this.getRange(1, 1, "month") },
      ],
    };
  },
  watch: {
    localFilters: {
      handler(newValue) {
        this.$emit("change", newValue);
      },
      deep: true,
    },
  },
  methods: {
    setFilters(filters) {
      this.localFilters = {
        ...this.localFilters,
        ...(filters || {}),
      };
    },
    handleChange(values) {
      if (!values || values.length < 2) return;

      const start = moment(values[0]);
      const end = moment(values[1]);

      if (end.diff(start, "days") > 30) {
        this.$store.commit("showSnackbar", {
          message: "O período não pode ser maior que 30 dias.",
          color: "error",
        });
        return;
      }

      this.localFilters.start_date = start.format("YYYY-MM-DD");
      this.localFilters.end_date = end.format("YYYY-MM-DD");
    },
    getRange(startOffset = 0, endOffset = 0, period = "day") {
      return [
        moment().subtract(startOffset, period).startOf(period),
        moment().subtract(endOffset, period).endOf(period),
      ];
    },
  },
};
</script>

<style scoped>
.is-disabled {
  pointer-events: none;
  opacity: 0.5;
  filter: grayscale(100%);
  cursor: not-allowed;
}
</style>
